<template>
    <div :class="preCls + 'content-box'">
        <!-- 筛选条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <form-lookup
                style="
                    min-width: 262px;
                    margin-right: 15px;
                    max-height: 90px;
                    overflow: auto;
                "
                v-model="selectRoom.roomId"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                :options.sync="selectRoom.roomList"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room multiple />
            </form-lookup>

            <!-- 高级搜索 -->
            <rechargeweflow-adv-search
                ref="adv"
                v-model="advFilter"
                @confirm="onAdvConfirm"
            ></rechargeweflow-adv-search>

            <!-- 已选中的搜索条件 -->
            <select-tags
                v-model="advOptions"
                style="margin-bottom: 4px"
                @close="onAdvItemClose"
            ></select-tags>
        </div>
        <!-- 列表工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="房源名称，客户名称，手机号搜索"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>

            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <!-- 表格 -->
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <!-- slot -->
        </Table>
        <!-- 分页组件 -->
        <table-pager
            :total="page.totalCount"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        />
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showForm"
            :title="actionTitle + '工单'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
        </smart-modal>
    </div>
</template>

<script>
import { mapCache } from '_g/vux-data-cache'
import mList from '_v/common/m-list'
import SelectRoom from '_vc/select-room'
import FilterDateRange from '_v/components/filter/filter-date-range'
import mRechargeweflowList from '_v/common/m-rechargeweflow-list.js'
import { ymdL } from '_u/helper'
import { getWeFlowList } from '@/api/order'

export default {
    name: 'orderRechaargeWeflow',
    mixins: [mList, mRechargeweflowList],
    // mixins: [mList],
    components: {
        SelectRoom,
        FilterDateRange,
    },
    data() {
        return {
            loading: false,
            loadingExport: false,
            mtHeight: 360,
            curId: '',
            page: {
                totalCount: 0,
                list: [],
            },
            dict: {
                tradeType: this.$dict.NULL,
            },
            modal: {
                showForm: false,
            },
            routerHouseId: this.$route.query.houseIds,
        }
    },
    computed: {
        ...mapCache({
            filter: 'rechargeFilter',
            selectRoom: 'dsSelectRoom',
            advFilter: 'dsAdvFilter',
            advOptions: 'dsAdvOptions',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '房源名称',
                    key: 'houseName',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '客户姓名',
                    key: 'cusName',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '客户手机号',
                    key: 'cusMobile',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '流水类型',
                    key: 'tradeTypeText',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '金额(元)',
                    key: 'tradeAmountText',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '水电余额(元)',
                    key: 'balanceText',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '时间',
                    key: 'createTimeText',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '操作人',
                    key: 'createUserName',
                    align: 'center',
                    minWidth: 170,
                },
                {
                    title: '备注',
                    key: 'remark',
                    align: 'center',
                    minWidth: 170,
                },
            ]
        },
    },
    methods: {
        isEmpty(n) {
            return (
                n === null ||
                n === undefined ||
                n === '' ||
                (n._isBigNumber && n.isNaN())
            )
        },
        // 获取数据
        fetch() {
            this.loading = true

            //取跳转到此页面时携带的参数
            if (this.routerHouseId != null) {
                var { houseIds, houseName } = this.$route.query

                this.filter.houseIds = this.routerHouseId
                //此方法待定
                this.selectRoom.roomId = this.routerHouseId
                this.selectRoom.roomList = [
                    {
                        id: houseIds,
                        title: houseName,
                    },
                ]
            }

            return Promise.all([
                this.$dict.get(['trade_type']), // 查词典
                getWeFlowList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ), // 查数据
            ])
                .then((args) => {
                    // this.routerHouseId = null

                    var [dict, view] = args

                    // 设置词典
                    Object.assign(this.dict, dict)

                    // 解析列表数据
                    this.page.list = this.normalizePageList(view.data.page.list)
                    this.page.totalCount = parseInt(view.data.page.totalCount)
                })
                .finally(() => (this.loading = false))
        },
        // 搜索
        search() {
            this.filter.page = 1
            this.fetch()
        },
        // 列表数据处理
        normalizePageList(list) {
            list.forEach((row) => {
                row.createTimeText = ymdL(row.createTime)
                row.tradeTypeText = this.dict.tradeType.val(row.tradeType)
            })
            return list
        },

        // 导出Excel
        onClickExport() {
            this.loadingExport = true

            getWeFlowList(
                Object.assign({}, this.filter, {
                    pageNo: 1,
                    pageSize: 99999,
                })
            )
                .then((res) => {
                    var $mt = this.$refs.mt
                    $mt.exportToExcel({
                        rows: this.normalizePageList(res.data.page.list),
                    })
                })
                .finally(() => {
                    this.loadingExport = false
                })
        },

        // 清除房间筛选
        onClearRoom() {
            this.routerHouseId = null
            this.selectRoom = {}
            this.search()
        },
        onDeselectRoom(e) {
            if (e == this.routerHouseId) {
                this.routerHouseId = null
                this.selectRoom = {}
                this.search()
            }
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        // 自适应高度
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                60
        })
    },
}
</script>

<style></style>
